import { render, staticRenderFns } from "./PurchaseReportList.vue?vue&type=template&id=c94f51b6&scoped=true&"
import script from "./PurchaseReportList.vue?vue&type=script&lang=js&"
export * from "./PurchaseReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94f51b6",
  null
  
)

export default component.exports